import { useParams, Link } from "react-router-dom";
import { categories, allArticles } from "@/mocks/siteData";
import ArticleCard from "@/components/feature/ArticleCard";
import Breadcrumb from "@/components/base/Breadcrumb";
import SEOHead from "@/components/base/SEOHead";

export default function CategoryPage() {
  const { categoryId } = useParams<{ categoryId: string }>();
  const category = categories.find((c) => c.id === categoryId);
  const categoryArticles = allArticles.filter((a) => a.categoryId === categoryId);

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-foreground-950 mb-2">分类不存在</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600 transition-colors">
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const categoryBannerUrl =
    "https://readdy.ai/api/search-image?query=Japanese%20manga%20and%20doujinshi%20art%20collection%20displayed%20on%20a%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20artistic%20and%20curated%20composition%2C%20soft%20natural%20colors%2C%20editorial%20photography%20style%2C%20clean%20and%20elegant%20aesthetic&width=1600&height=500&seq=category-banner-generic&orientation=landscape";

  return (
    <>
      <SEOHead
        title={`${category.name} - 本子漫画导航`}
        description={category.description}
        keywords={`本子漫画,${category.name},日系漫画本子,漫画同人志`}
        canonicalPath={`/category/${categoryId}`}
      />
      <div className="min-h-screen bg-background-50 pt-16">
        <div className="relative h-48 md:h-64 overflow-hidden">
          <img src={categoryBannerUrl} alt={category.name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center px-4">
              <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">{category.name}</h1>
              <p className="text-white/70 text-sm md:text-base max-w-md mx-auto">{category.description}</p>
            </div>
          </div>
        </div>

        <Breadcrumb />

        <div className="max-w-7xl mx-auto px-4 md:px-6 mt-8 mb-6">
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  cat.id === categoryId
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-20">
          {categoryArticles.length > 0 ? (
            <>
              <p className="text-sm text-foreground-500 mb-5">
                共 {categoryArticles.length} 篇文章
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    excerpt={article.excerpt}
                    categoryName={category.name}
                    tags={article.tags}
                    author={article.author}
                    date={article.date}
                    readCount={article.readCount}
                    imageUrl={article.imageUrl}
                  />
                ))}
              </div>
            </>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500 mb-4">该分类下暂无文章</p>
              <Link to="/" className="text-primary-500 hover:text-primary-600 transition-colors">
                返回首页查看更多内容
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}